import o from "./index820.js";
var m = o.Symbol;
export {
  m as default
};
